var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 5.5V4.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 5.5H7.97095C7.65938 5.50022 7.35759 5.60884 7.11735 5.80723C6.87712 6.00563 6.71339 6.28143 6.65427 6.58734C6.59515 6.89325 6.6443 7.21019 6.79331 7.48382C6.94232 7.75745 7.1819 7.9707 7.47095 8.087L9.53495 8.913C9.824 9.0293 10.0636 9.24255 10.2126 9.51618C10.3616 9.78981 10.4108 10.1068 10.3516 10.4127C10.2925 10.7186 10.1288 10.9944 9.88854 11.1928C9.6483 11.3912 9.34652 11.4998 9.03495 11.5H6.99995",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 12.5V11.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5C20.5 22.7652 20.3946 23.0196 20.2071 23.2071C20.0196 23.3946 19.7652 23.5 19.5 23.5H4.5C4.23478 23.5 3.98043 23.3946 3.79289 23.2071C3.60536 23.0196 3.5 22.7652 3.5 22.5V1.5C3.5 1.23479 3.60536 0.980433 3.79289 0.792897C3.98043 0.605361 4.23478 0.500004 4.5 0.500004H14.09C14.2218 0.499637 14.3524 0.525335 14.4743 0.575619C14.5961 0.625903 14.7068 0.699781 14.8 0.793004L20.214 6.207C20.4016 6.3945 20.5069 6.64881 20.507 6.914L20.5 22.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.589844V5.49984C14.5 5.76506 14.6054 6.01941 14.7929 6.20695C14.9804 6.39449 15.2348 6.49984 15.5 6.49984H20.41",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58691 16.5H17.5039",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.52 13.5H17.504",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 10.5H17.5039",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58691 19.5H17.5039",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.7743e7bab2f66d375c696218149f84c1.svg";
export { ForwardRef as ReactComponent };